
import React from "react";
import { useTranslation } from "react-i18next";
import { useTelemetry } from "../../context/TelemetryContext";
import ModeIndicator from "../../components/shared/ModeIndicator";
import LanguageToggle from "../../components/shared/LanguageToggle";
import SubPageNav from "../../components/shared/SubPageNav";
import { useIndustry } from "../../context/IndustryContext";

const INDUSTRY_REC_KEY = {
  "School": "school",
  "Airport": "airport",
  "Public Event": "publicEvent",
  "Border Security": "borderSecurity",
  "Military": "military",
};

function MissionControl() {
const { t } = useTranslation();
const { industry } = useIndustry();

const telemetry = useTelemetry();
const missionConfidence =
telemetry.overallRisk === "CRITICAL"
? 94
: telemetry.overallRisk === "WARNING"
? 82
: 98;

const industryKey = INDUSTRY_REC_KEY[industry];
const riskKey =
telemetry.overallRisk === "CRITICAL"
? "critical"
: telemetry.overallRisk === "WARNING"
? "warning"
: "safe";

const recommendations = industryKey
? t(`missionControl.recs.${industryKey}.${riskKey}`, { returnObjects: true })
: t("missionControl.recs.default", { returnObjects: true });


return (

<div
style={{
padding: "20px",
color: "white"
}}
>
<div style={{position:"relative",textAlign:"center",marginBottom:"20px"}}><h1
style={{
textAlign:"center",
marginBottom:"10px"
}}
>
{t("missionControl.title")}
</h1><div style={{position:"absolute",top:0,right:0,display:"flex",alignItems:"flex-start",gap:"12px"}}><LanguageToggle /><ModeIndicator /></div></div>

<p
style={{
textAlign:"center",
color:"#94a3b8",
marginBottom:"30px"
}}
>
{t("missionControl.subtitle")}
</p>

<div
style={{
display: "grid",
gridTemplateColumns: "1fr 1fr",
gap: "20px"
}}
>

{/* Facility Status */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("missionControl.missionState.title")}</h3>

<h1
style={{
marginTop: "15px",
color:
telemetry.overallRisk === "CRITICAL"
? "#ef4444"
: telemetry.overallRisk === "WARNING"
? "#f59e0b"
: "#22c55e"
}}
>
{t(`commandCenter.risk.${telemetry.overallRisk}`, telemetry.overallRisk)}
</h1>

<p style={{ color: "#94a3b8" }}>
{t("missionControl.missionState.operationalState")}
</p>

<div style={{ marginTop: "15px" }}>
{t("missionControl.missionState.confidenceScore", { value: missionConfidence })}
</div>

</div>

{/* AI Recommendations */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("missionControl.directives.title")}</h3>

<div style={{ marginTop: "15px" }}>

{recommendations.map((item, index) => (

<div
key={index}
style={{
marginBottom: "10px",
color: "#94a3b8"
}}
>
• {item}
</div>

))}

</div>

</div>

{/* Zone Summary */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("missionControl.zoneSummary.title")}</h3>

<div style={{ marginTop: "15px" }}>

{telemetry.zones?.map((zone, index) => (

<div
key={index}
style={{
display: "flex",
justifyContent: "space-between",
marginBottom: "10px"
}}
>
<span>{t(`commandCenter.regionalRiskMap.${zone.zone}`, zone.zone)}</span>

<span
style={{
fontWeight: "bold",
color:
zone.risk === "CRITICAL"
? "#ef4444"
: zone.risk === "WARNING"
? "#f59e0b"
: "#22c55e"
}}
>
{t(`commandCenter.risk.${zone.risk}`, zone.risk)}
</span>

</div>

))}

</div>

</div>

{/* Mission Oversight */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("missionControl.oversight.title")}</h3>

<div style={{ marginTop: "15px" }}>

<p>{t("missionControl.oversight.exposureSignal", { value: telemetry.fentanyl_ppb })}</p>

<p>{t("missionControl.oversight.pm25", { value: telemetry.pm25 })}</p>

<p>{t("missionControl.oversight.voc", { value: telemetry.voc })}</p>

<p style={{ marginTop: "15px", color: "#22c55e" }}>
{t("missionControl.oversight.humanSupervisionActive")}
</p>

</div>

</div>

</div>

{/* ===================================================== */}
{/* MISSION COMMAND OVERVIEW */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("missionControl.commandOverview.title")}
</h3>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px"
}}
>

<div style={{textAlign:"center"}}>
<h4>{t("missionControl.commandOverview.operationalStatus")}</h4>
<h2
style={{
color:
telemetry.overallRisk === "CRITICAL"
? "#ef4444"
: telemetry.overallRisk === "WARNING"
? "#f59e0b"
: "#22c55e"
}}
>
{t("commandCenter.status.active")}
</h2>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("missionControl.commandOverview.responseTeams")}</h4>
<h2 style={{color:"#38bdf8"}}>
4
</h2>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("missionControl.commandOverview.activeIncidents")}</h4>
<h2 style={{color:"#f59e0b"}}>
2
</h2>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("missionControl.commandOverview.aiConfidence")}</h4>
<h2
style={{
color:
missionConfidence > 85
? "#22c55e"
: missionConfidence > 60
? "#f59e0b"
: "#ef4444"
}}
>
{missionConfidence}%
</h2>
</div>

</div>

</div>

{/* ===================================================== */}
{/* INCIDENT COMMAND BOARD */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("missionControl.incidentCommandBoard.title")}
</h3>

<table
style={{
width:"100%",
textAlign:"center"
}}
>

<thead>

<tr>
<th>{t("missionControl.incidentCommandBoard.incident")}</th>
<th>{t("missionControl.incidentCommandBoard.priority")}</th>
<th>{t("missionControl.incidentCommandBoard.status")}</th>
<th>{t("missionControl.incidentCommandBoard.team")}</th>
</tr>

</thead>

<tbody>

{telemetry.zones?.map((zone, index) => {
const teamKeys = ["teamAlpha", "teamBravo", "teamCharlie"];
const riskColor =
zone.risk === "CRITICAL" ? "#ef4444" : zone.risk === "WARNING" ? "#f59e0b" : "#22c55e";
return (
<tr key={zone.zone}>
<td>{t(`commandCenter.regionalRiskMap.${zone.zone}`, zone.zone)}</td>
<td style={{color:riskColor}}>{t(`commandCenter.risk.${zone.risk}`, zone.risk)}</td>
<td>{zone.risk === "SAFE" ? t("commandCenter.status.closed") : t("commandCenter.status.active")}</td>
<td>{t(`missionControl.incidentCommandBoard.${teamKeys[index]}`)}</td>
</tr>
);
})}

</tbody>

</table>

</div>

{/* ===================================================== */}
{/* RESPONSE TEAM DEPLOYMENT */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("missionControl.deployment.title")}
</h3>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px"
}}
>

<div style={{textAlign:"center"}}>
<h4>{t("missionControl.deployment.teamAlpha")}</h4>
<p style={{color:"#f59e0b"}}>
{t("missionControl.deployment.pendingApproval")}
</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("missionControl.deployment.teamBravo")}</h4>
<p style={{color:"#f59e0b"}}>
{t("commandCenter.status.standby")}
</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("missionControl.deployment.teamCharlie")}</h4>
<p style={{color:"#22c55e"}}>
{t("commandCenter.status.available")}
</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("missionControl.deployment.rapidResponse")}</h4>
<p style={{color:"#38bdf8"}}>
{t("commandCenter.status.ready")}
</p>
</div>

</div>

<hr
style={{
border:"1px solid #1e293b",
margin:"25px 0"
}}
/>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px"
}}
>

<div style={{textAlign:"center"}}>
<h4>{t("missionControl.deployment.personnel")}</h4>
<h2 style={{color:"#38bdf8"}}>48</h2>
<p>{t("missionControl.deployment.availableLabel")}</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("missionControl.deployment.securityUnits")}</h4>
<h2 style={{color:"#22c55e"}}>12</h2>
<p>{t("missionControl.deployment.readyLabel")}</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("missionControl.deployment.medicalSupport")}</h4>
<h2 style={{color:"#f59e0b"}}>6</h2>
<p>{t("missionControl.deployment.availableLabel")}</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("missionControl.deployment.responseVehicles")}</h4>
<h2 style={{color:"#f59e0b"}}>8</h2>
<p>{t("missionControl.deployment.pendingApproval")}</p>
</div>

</div>

</div>



{/* ===================================================== */}
{/* MISSION AGENT NETWORK */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("missionControl.agentNetwork.title")}
</h3>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px",
textAlign:"center"
}}
>

<div>
<h4>{t("missionControl.agentNetwork.missionAgent")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

<div>
<h4>{t("missionControl.agentNetwork.decisionAgent")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

<div>
<h4>{t("missionControl.agentNetwork.recommendationAgent")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

<div>
<h4>{t("missionControl.agentNetwork.governanceAgent")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

</div>

</div>

{/* ===================================================== */}
{/* LIVE COORDINATION FEED */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("missionControl.coordinationFeed.title")}
</h3>

<div
style={{
textAlign:"center",
color:"#cbd5e1",
lineHeight:"2"
}}
>

{
telemetry.overallRisk === "CRITICAL"
?
<>
{t("missionControl.coordinationFeed.criticalLine1")}
&nbsp; | &nbsp;
{t("missionControl.coordinationFeed.criticalLine2")}
&nbsp; | &nbsp;
{t("missionControl.coordinationFeed.criticalLine3")}
&nbsp; | &nbsp;
{t("missionControl.coordinationFeed.criticalLine4")}
</>
:
telemetry.overallRisk === "WARNING"
?
<>
{t("missionControl.coordinationFeed.warningLine1")}
&nbsp; | &nbsp;
{t("missionControl.coordinationFeed.warningLine2")}
&nbsp; | &nbsp;
{t("missionControl.coordinationFeed.warningLine3")}
&nbsp; | &nbsp;
{t("missionControl.coordinationFeed.warningLine4")}
</>
:
<>
{t("missionControl.coordinationFeed.safeLine1")}
&nbsp; | &nbsp;
{t("missionControl.coordinationFeed.safeLine2")}
&nbsp; | &nbsp;
{t("missionControl.coordinationFeed.safeLine3")}
&nbsp; | &nbsp;
{t("missionControl.coordinationFeed.safeLine4")}
</>
}

</div>
</div>

{/* ===================================================== */}
{/* MISSION CONFIDENCE METER */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("missionControl.confidenceMeter.title")}
</h3>

<div
style={{
width:"100%",
height:"28px",
background:"#0f172a",
borderRadius:"20px",
overflow:"hidden"
}}
>

<div
style={{
width:`${missionConfidence}%`,
height:"100%",
background:
missionConfidence > 85
? "#22c55e"
: missionConfidence > 60
? "#f59e0b"
: "#ef4444"
}}
/>

</div>

<div
style={{
textAlign:"center",
marginTop:"12px",
fontSize:"24px",
fontWeight:"bold"
}}
>
{missionConfidence}%
</div>

</div>

{/* ===================================================== */}
{/* MISSION RECOMMENDATIONS */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("missionControl.recommendations.title")}
</h3>

<div
style={{
display:"flex",
justifyContent:"center",
gap:"40px",
flexWrap:"wrap",
color:"#cbd5e1"
}}
>

{
telemetry.overallRisk === "CRITICAL"
?
<>
<span>{t("missionControl.recommendations.criticalActivate")}</span>
<span>{t("missionControl.recommendations.criticalNotify")}</span>
<span>{t("missionControl.recommendations.criticalEscalate")}</span>
</>
:
telemetry.overallRisk === "WARNING"
?
<>
<span>{t("missionControl.recommendations.warningIncrease")}</span>
<span>{t("missionControl.recommendations.warningPrepare")}</span>
<span>{t("missionControl.recommendations.warningNotify")}</span>
</>
:
<>
<span>{t("missionControl.recommendations.safeContinue")}</span>
<span>{t("missionControl.recommendations.safeMaintain")}</span>
<span>{t("missionControl.recommendations.safeValidate")}</span>
</>
}

</div>

</div>

{/* ===================================================== */}
{/* EXECUTIVE MISSION SUMMARY */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b",
textAlign:"center"
}}
>

<h3>
{t("missionControl.summary.title")}
</h3>

<p
style={{
marginTop:"15px",
color:"#94a3b8",
lineHeight:"1.8"
}}
>
{t("missionControl.summary.text")}
</p>

</div>

<SubPageNav current="missionControl" />

</div>

);

}

export default MissionControl;